import { useTranslation } from "@l2r-front/l2r-i18n"
import { useTheme } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../common/constants/i18n"

import { getRiskZonesLegendConfig } from "../utils/getRiskZonesConfig"

export function useRiskZonesLegend() {

    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()

    return [
        {
            layerName: "riskZones",
            legendData: getRiskZonesLegendConfig(t, theme),
            title: t(I18N_NAMESPACE, "containers.riskZones.legend.title"),
        },
    ]
}